<template>
  <div class="columnTranslation">
    <div v-for="translation, index in value" class="column">
      <div class="field mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
        <input class="mdl-textfield__input" type="text" :id="'translation_key_'+translation.from"
               :value="translation.from" @input="updateFrom(index, $event.target.value)"
               v-bind:required="required" :ref="'translation_key_'+translation.from">
        <label class="mdl-textfield__label" :for="'translation_key_'+translation.from">Translate From</label>
      </div>
      <SingleSelect :value="translation.to" @input="value => updateTo(index, value)" :options="targets"></SingleSelect>
      <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent del-translation"
              @click="deleteTranslation(index)"><i class="material-icons">delete_forever</i></button>

      <div v-if="errors[index]" class="error">{{ errors[index] }}</div>
    </div>
    <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-translation"
            @click="addTranslation"><i class="material-icons">add</i></button>
  </div>
</template>

<script>
  import SingleSelect from '../utils/SingleSelect.vue'

  export default {
    name: "ColumnTranslation",
    components: {
      SingleSelect
    },
    props: {
      value: {
        type: Array
      },
      targets: {
        type: Array
      }
    },
    data() {
      return {
        required: true,
        errors: new Array(this.value.length)
      }
    },
    watch: {
      value(v) {
        this.computeErrors()
      }
    },
    computed: {

    },
    methods: {
      updateFrom(index, value) {
        this.value[index].from = value
        this.computeErrors()
        this.$emit('input', this.value)
      },
      updateTo(index, value) {
        console.log("UPDATE TO", index, value)
        this.value[index].to = value
        this.computeErrors()
        this.value.errors = this.errors
        this.$emit('input', this.value)
      },
      computeErrors() {
        let froms = new Set()
        let errors = new Array(this.value.length)
        for(let i = 0; i < this.value.length; i++) {
          let tr = this.value[i]
          if( froms.has(tr.from) )
            errors[i] = `Duplicate Entry - there is another position which translates from ${tr.from}`
          froms.add(tr.from)
        }
        this.errors = errors
      },
      addTranslation() {
        this.value.push({
          from: this.targets[0],
          to: this.targets[0]
        })
        this.value.errors = this.errors
        this.$emit('input', this.value)
      },
      deleteTranslation(index) {
        this.value.splice(index, 1)
        this.value.errors = this.errors
        this.$emit('input', this.value)
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
      this.computeErrors()
    }
  }
</script>

<style scoped>


  button.add-translation {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  button.add-translation > i {
    font-size: 20px;
  }

  button.del-translation {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  button.del-translation > i {
    font-size: 20px;
  }

  .error {
    position: relative;
    top: -16px;
    color: #af0000;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// ColumnTranslation.vue?47250f4d